import i18n from '@/lang'

// 公司类型选项
export function getCompanyTypeOptions() {
  return [
    { label: i18n.t('kyc.company_info_company_type_option_limited'), value: 'limited' },
    { label: i18n.t('kyc.company_info_company_type_option_partnership'), value: 'partnership' },
    { label: i18n.t('kyc.company_info_company_type_option_sole'), value: 'sole' }
  ]
}

// 货币选项
export function getCurrencyOptions() {
  return [
    { label: i18n.t('kyc.company_info_currency_option_usd'), value: 'usd' },
    { label: i18n.t('kyc.company_info_currency_option_thb'), value: 'thb' },
    { label: i18n.t('kyc.company_info_currency_option_sgd'), value: 'sgd' },
    { label: i18n.t('kyc.company_info_currency_option_other'), value: 'other' }
  ]
}

// 账户信息货币选项
export function getAccountCurrencyOptions() {
  return [
    { label: i18n.t('kyc.account_info_currency_option_usd'), value: 'usd' },
    { label: i18n.t('kyc.account_info_currency_option_thb'), value: 'thb' },
    { label: i18n.t('kyc.account_info_currency_option_sgd'), value: 'sgd' },
    { label: i18n.t('kyc.account_info_currency_option_other'), value: 'other' }
  ]
}

// 国籍选项
export function getNationalityOptions() {
  return [
    { label: i18n.t('kyc.signatory_info_nationality_option_th'), value: 'th' },
    { label: i18n.t('kyc.signatory_info_nationality_option_sg'), value: 'sg' },
    { label: i18n.t('kyc.signatory_info_nationality_option_other'), value: 'other' }
  ]
}

// 职位选项
export function getPositionOptions() {
  return [
    { label: i18n.t('kyc.signatory_info_position_option_director'), value: 'director' },
    { label: i18n.t('kyc.signatory_info_position_option_auth_signatory'), value: 'auth_signatory' },
    { label: i18n.t('kyc.signatory_info_position_option_other'), value: 'other' }
  ]
}

